import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class SigtripStaffsPendingSchedules extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.exportPdfGrade = this.exportPdfGrade.bind(this);
    this.confirmSchedule = this.confirmSchedule.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador/pendencias/grades', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  exportPdfGrade(id, type) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    if (type === 'sigtrip') {
      var api = 'api';
      var cdn = 'cdn';
      var route = '/exportar/pdf/escala-grade/' + id;
      var pdf = '/schedule_grades/main/';
    }
    else if (type === 'sigmec') {
      var api = 'api_sigmec';
      var cdn = 'cdn_sigmec';
      var route = '/exportar/escala/grade/visualizar/' + id + '/2';
      var pdf = '/tmp/';
    }
    Promise.resolve(header).then(function(value) {
      var url = config.get(api) + route;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        window.open(config.get(cdn) + pdf + responseJson.data);
      })
    });
  }

  confirmSchedule(id) {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      id: id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador/pendencias/grade/confirmar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.loadData();
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {
      
    var botao = "";
      
    if(row.type === 'sigmec') {
        botao = (
            <div className="btn-group">
                <button onClick={() => this.exportPdfGrade(row.schedule_grade_id, 'sigmec')} className="btn btn-warning button-inline"><i className="fa fa-fw fa-file-pdf-o"></i> {this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.botaoRevisao} {row.schedule_grade_revision}</button>
                <button className={'btn btn-success button-inline'} onClick={() => this.confirmSchedule(row.id)}>
                    <i className="fa fa-fw fa-check"></i>
                </button>
            </div>
        );
    }
    if(row.type === 'sigtrip') {
        botao = (
            <div className="btn-group">
                <button onClick={() => this.exportPdfGrade(row.schedule_grade_id, 'sigtrip')} className="btn btn-warning button-inline"><i className="fa fa-fw fa-file-pdf-o"></i> {this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.botaoRevisao} {row.schedule_grade_revision}</button>
                <button className={'btn btn-success button-inline'} onClick={() => this.confirmSchedule(row.id)}>
                    <i className="fa fa-fw fa-check"></i>
                </button>
            </div>
        );
    }

    return botao;
  }

  render() {
    return (
<div>
    {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
        <h3 className="page-title">{this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.titulo}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.semEscalas}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='60'>{this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Mes}</TableHeaderColumn>
        <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Base}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Frota}</TableHeaderColumn>
        <TableHeaderColumn dataField="schedule_grade_revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Revisao}</TableHeaderColumn>
        <TableHeaderColumn dataField="schedule_grade_status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Status}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>{this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default SigtripStaffsPendingSchedules;



// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/SigtripStaffsPendingSchedules.js